import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs';
import {
  SendCodeRequest,
  SignInWithPasswordRequest,
  VerifyCodeRequest,
} from '../components/layout/right-sidebar/components/integration-telegram-user/integration-telegram-user.interface';

@Injectable({
  providedIn: 'root'
})
export class IntegrationTelegramService {

  constructor(
    private readonly http: HttpClient,
  ) {
  }

  sendCode(payload: SendCodeRequest) {
    return this.http.post<any>(environment.baseURL + '/tg-user/send-code', payload)
      .pipe(map(v => v.data));
  }

  verifyCode(payload: VerifyCodeRequest) {
    return this.http.post<any>(environment.baseURL + '/tg-user/verify-code', payload);
  }

  signInWithPassword(payload: SignInWithPasswordRequest) {
    return this.http.post<any>(environment.baseURL + '/tg-user/verify-pass', payload);
  }

  signInWithQRCode(channel_id: string) {
    return this.http.post<any>(environment.baseURL + '/tg-user/qr-code', { channel_id })
      .pipe(map(v => v.data));
  }

  checkAuthorization(channel_id: string) {
    return this.http.get<any>(environment.baseURL + `/tg-user/${channel_id}`)
      .pipe(map(v => v.data));
  }

  logOut(channel_id: string) {
    return this.http.post<any>(environment.baseURL + '/tg-user/log-out', { channel_id });
  }
}
